import { pathBuilder } from 'config/paths/index';

export const root = '/admin/containers';
export default pathBuilder(root);
